if (typeof Blazy === 'function') {
    var bLazy;
}

// custom tags
if(typeof document.registerElement === 'function') {
    var rSpanElement = document.registerElement('r-span');
}

$.fn.hasAttr = function(name) {
   return this.attr(name) !== undefined;
};

$.fn.slideHere = function(offset, time) {
    if (typeof offset == 'undefined') {
        offset = 15;
    }

    if (typeof time == 'undefined') {
        time = 400;
    }

    $('html, body').animate({
        scrollTop: this.offset().top - offset
    }, time);
};

// underscode template settings
_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g
};

function toggleOverlay(time) {
    if (typeof time == 'undefined') {
        time = 250;
    }

    $('.c-overlay').toggleClass('is-active');
}

function showOverlay(time) {
    if (typeof time == 'undefined') {
        time = 250;
    }

    $('.c-overlay').addClass('is-active');
    $('body').addClass('is-overlayed');
}

function hideOverlay(time) {
    if (typeof time == 'undefined') {
        time = 250;
    }

    $('.c-overlay').removeClass('is-active');
    $('body').removeClass('is-overlayed');
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
}

function slideTo($element, offset, time) {
    $element.slideHere(offset, time);
}

$(function() {
    if (typeof Blazy === 'function') {
        bLazy = new Blazy({
            selector: '.js-blazy',
            successClass: 'is-loaded',
            offset: $(window).height() / 2,
            success: function(ele) {
                var url = $(ele).css('background-image');

                ele.style.setProperty('background-image', url, 'important');
            }
        });
    }

    if (typeof tippy === 'function') {
        tippy('.js-tippy', {
            arrow: true
        });
    }

    // ajax setup
    $.ajaxSetup({
        headers: {
            "X-CSRF-Token": getCookie('csrfToken')
        }
    });

    // show lightbox
    $('.lightbox').bind('click', function() {
        var $this = $(this);
        Eshop.lightbox($this.attr('href'), {
            'title': $this.children('img').attr('alt')
        });

        return false;
    });

    $('.c-overlay').on('click', function() {
        hideOverlay();
    });

    $('.js-print').on('click', function(event) {
        event.preventDefault();

        window.print();
    });
});
